import React, { useMemo } from "react";
import { useTranslate } from "@refinedev/core";
import {
  FunnelCard,
  type FunnelStep,
  type FunnelConnector,
} from "./FunnelCard";
import { formatPct } from "./utils/";
import { analyticsTheme } from "./analyticsTheme";

const T_PREFIX = "media.projects.analytics.dashboard.summaryCards.playFunnel";

export interface PlayFunnelData {
  impressionSessions: number;
  playSessions: number;
  playRate: number;
}

interface PlayFunnelCardProps {
  data: PlayFunnelData;
  loading?: boolean;
}

export const PlayFunnelCard: React.FC<PlayFunnelCardProps> = ({
  data: funnelData,
  loading,
}) => {
  const t = useTranslate();
  const { impressionSessions, playSessions, playRate } = funnelData;

  const steps = useMemo<FunnelStep[]>(
    () => [
      {
        label: t(`${T_PREFIX}.impression`),
        percentage: 100,
        count: impressionSessions,
        color: analyticsTheme.datasetCharcoal,
      },
      {
        label: t(`${T_PREFIX}.play`),
        percentage: playRate,
        count: playSessions,
        color: analyticsTheme.datasetEmerald,
      },
    ],
    [impressionSessions, playRate, playSessions, t]
  );

  const connectors = useMemo<FunnelConnector[]>(
    () => [
      {
        text: `${formatPct(playRate)} · ${t(T_PREFIX + ".viewersPlayed")}`,
      },
    ],
    [playRate, t]
  );

  return (
    <FunnelCard
      title={t(`${T_PREFIX}.title`)}
      steps={steps}
      connectors={connectors}
      loading={loading}
    />
  );
};
